import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerPWA } from "@/pwa";

// Comprehensive error suppression for external scripts (TradingView, etc.)
if (typeof window !== 'undefined') {
  // Suppress global errors from external scripts
  const origError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    // Suppress "Script error." which comes from cross-origin scripts
    if (message === 'Script error.' || message === 'Script error') {
      return true;
    }
    // Suppress errors from TradingView or other external CDNs
    if (source && (
      source.includes('tradingview.com') ||
      source.includes('s3.tradingview.com') ||
      source.includes('finnhub.io') ||
      source === ''
    )) {
      return true;
    }
    if (origError) return origError(message, source, lineno, colno, error);
    return false;
  };

  // Suppress unhandled promise rejections from external scripts
  window.addEventListener('unhandledrejection', function(event) {
    const reason = event.reason;
    if (reason && (
      reason.message?.includes('Script error') ||
      reason.message?.includes('tradingview') ||
      reason.message?.includes('finnhub') ||
      reason.message?.includes('Failed to fetch') ||
      reason.message?.includes('Load failed')
    )) {
      event.preventDefault();
      return;
    }
  });

  // Override console.error to suppress specific errors
  const origConsoleError = console.error;
  console.error = function(...args) {
    const errorString = args.join(' ');
    // Suppress TradingView and external script errors
    if (
      errorString.includes('tradingview') ||
      errorString.includes('TradingView') ||
      errorString.includes('finnhub') ||
      errorString.includes('Script error') ||
      errorString.includes('ERR_BLOCKED') ||
      errorString.includes('ResizeObserver') ||
      (errorString.includes('Failed to load') && errorString.includes('external'))
    ) {
      return;
    }
    origConsoleError.apply(console, args);
  };

  // Disable React error overlay for specific errors in development
  if (process.env.NODE_ENV === 'development') {
    const hideOverlay = () => {
      const overlay = document.querySelector('iframe[style*="position: fixed"]');
      if (overlay && overlay.contentDocument) {
        const errorTitle = overlay.contentDocument.body?.textContent || '';
        if (
          errorTitle.includes('Script error') ||
          errorTitle.includes('handleError') ||
          errorTitle.includes('tradingview')
        ) {
          overlay.style.display = 'none';
        }
      }
      // Also try to find and hide the webpack-dev-server overlay
      const webpackOverlay = document.getElementById('webpack-dev-server-client-overlay');
      if (webpackOverlay) {
        const content = webpackOverlay.shadowRoot?.textContent || webpackOverlay.textContent || '';
        if (
          content.includes('Script error') ||
          content.includes('handleError')
        ) {
          webpackOverlay.style.display = 'none';
        }
      }
    };
    
    // Check periodically for error overlay and hide if it's external script error
    setInterval(hideOverlay, 500);
    
    // Also check on any error event
    window.addEventListener('error', hideOverlay, true);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA — service worker + capture beforeinstallprompt
registerPWA();
